export enum MARK {
  EMPTY_STATE = "empty_state_time_start",
  SUGGEST = "suggest_time_start",
  SUGGEST_RENDER = "suggest_render_time_start"
}
